import {MenuComponent} from '../js/custom-components/nav/menu-component';
import {MainElement} from '../js/custom-components/general/main-element-component';
import {SpecialsWidgetComponent} from '../js/custom-components/specials/specials-widget-component';

const {
  HashRouter,
  Route
} = window.ReactRouterDOM;

var config = {
	apiKey: "AIzaSyB-BXaGkInwL_GVpsyO4tydhxpwrd9k8Yo",
	authDomain: "emmanuellainasportfolioproject.firebaseapp.com",
	databaseURL: "https://emmanuellainasportfolioproject.firebaseio.com",
	projectId: "emmanuellainasportfolioproject",
	storageBucket: "emmanuellainasportfolioproject.appspot.com",
	messagingSenderId: "293889707758"
};
firebase.initializeApp(config);

class PortfolioEmmanuelLainas extends React.Component{
	constructor(props) {
    super(props);
    this.state = {
			notificationWidgetActive: false,
			scrollTimeout: null,
			scrollActive: true,
			aboutScrollPosition: "",
			projectsScrollPosition: "",
			menuIsVisible: false,
			menuEntires : [
			{
				name: "Bubbles",
				iconClass: "fa icon-fa-grav nav__link__icon",
				link: "/bubbles"								
			},
			{
				name: "Projects and Work",
				iconClass: "fa icon-box nav__link__icon",
				link: "/projects"								
			},
			{
				name: "About",
				iconClass: "fa icon-user-circle-o nav__link__icon",
				link: "/about"								
			}]
		};
		
		this.scrollToLocation = this.scrollToLocation.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.handleResize = this.handleResize.bind(this);
		this.toggleNotificationWidget = this.toggleNotificationWidget.bind(this);
		this.siteLoadedBootstrap = this.siteLoadedBootstrap.bind(this);
		
		this.animate = this.animate.bind(this);
		this.configureScrollTween = this.configureScrollTween.bind(this);
		this.offset = this.offset.bind(this);
		this.Tween = null;
		
		this.props.history.listen((location, action) => {
			if(this.state.scrollActive){
				this.scrollToLocation(location.pathname);
			}
			ga('set', 'page', location.pathname +'.html');
			ga('send', 'pageview');
		});
  }

	scrollToLocation(path){
		let currentPosition = window.pageYOffset;
		let el, elementPos;
		switch(path){
			case '/bubbles':
				this.configureScrollTween(currentPosition, 0, 1500);
				this.animate();
				//TweenMax.to(window, 2, {scrollTo:0, autoKill:false});
				break;
			case '/projects':
				el = document.querySelector('#projects__block');
				elementPos = this.offset(el);
				this.configureScrollTween(currentPosition, elementPos.top, 1500);
				this.animate();
				//TweenMax.to(window, 2, {scrollTo:"#projects__block", autoKill:false});
				break;
			case '/about':
				el = document.querySelector('#about__block');
				elementPos = this.offset(el);
				this.configureScrollTween(currentPosition, elementPos.top, 1500);
				this.animate();
				//TweenMax.to(window, 2, {scrollTo:"#about__block", autoKill:false});
				break;
		}
	}
	animate(){
			if (TWEEN.update()) {
					requestAnimationFrame(this.animate);
			}
	};
	configureScrollTween(from, to, duration){
			let coords = { y: from };
			//let scrollArea = document.querySelector('#app .app-wrapper');
			this.Tween = new TWEEN.Tween(coords)
					.easing(TWEEN.Easing.Quadratic.Out)
					.to({ y: to }, duration)
					.onUpdate(function() {
							//scrollArea.scrollTop = coords.y;
							window.scrollTo(0, coords.y);
					})
					.start();
	};

	offset(el){
			//let scrollArea = document.querySelector('#app .app-wrapper');
			let rect = el.getBoundingClientRect(),
					// scrollLeft = scrollArea.scrollLeft,
					// scrollTop = scrollArea.scrollTop;
					scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
					scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
	};

	handleScroll(){
		var scrollTimeout;
		window.requestAnimationFrame( () => {
			clearTimeout(this.state.scrollTimeout);
			scrollTimeout = setTimeout( () => {
				var scrollPosition = window.pageYOffset;
				if( scrollPosition>= 0 && scrollPosition < this.state.projectsScrollPosition - 200){
					if(this.props.location.pathname !== '/bubbles'){
						this.setState({scrollActive: false}, () => {
							this.props.history.push('/bubbles');
						});
					}
				} else if(scrollPosition >= this.state.projectsScrollPosition - 200 && scrollPosition < this.state.aboutScrollPosition - 200 ){
					if(this.props.location.pathname !== '/projects'){
						this.setState({scrollActive: false}, () => {
							this.props.history.push('/projects');
						});
					}
				} else if (scrollPosition >= this.state.aboutScrollPosition - 200){
					if(this.props.location.pathname !== '/about'){
						this.setState({scrollActive: false}, () => {
							this.props.history.push('/about');
						});
					}
				}
				this.setState({scrollActive: true});
			}, 50);				
			this.setState({scrollTimeout: scrollTimeout});
		});
	}
	
	handleResize(){
		var app_root = document.getElementById("app-root");
		var about__block = document.getElementById("about__block");
		var projects__block = document.getElementById("projects__block");
		
		this.setState({
			projectsScrollPosition : projects__block.offsetTop + app_root.offsetTop,
			aboutScrollPosition: about__block.offsetTop + app_root.offsetTop
		});
	}
	
	toggleNotificationWidget(){
		if(this.state.notificationWidgetActive){
			this.setState({notificationWidgetActive: false});
		} else {
			this.setState({notificationWidgetActive: true});
		}
	}
	siteLoadedBootstrap(){
		this.setState({menuIsVisible: true});
		document.getElementById('click-bubbles-text').className += " hide";
		setTimeout( this.scrollToLocation(this.props.location.pathname), 500);
	}
			
  componentDidMount() {
		var app_root = document.getElementById("app-root");
		var about__block = document.getElementById("about__block");
		var projects__block = document.getElementById("projects__block");
				
		this.setState({
			projectsScrollPosition : projects__block.offsetTop + app_root.offsetTop,
			aboutScrollPosition: about__block.offsetTop + app_root.offsetTop
		});
		window.addEventListener("resize", this.handleResize, false);
		window.addEventListener("scroll", this.handleScroll, false);
		window.addEventListener("load", this.siteLoadedBootstrap, false);
		
		if(this.props.location.pathname !== '/projects' && this.props.location.pathname !== '/about'){
			this.props.history.replace('bubbles')
		}
	}
	
  componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize, false);
		window.removeEventListener("scroll", this.handleScroll, false);
		window.removeEventListener("load", this.siteLoadedBootstrap, false);
  }
	
	render() {			
		return(
			<div>				
				<MenuComponent 
					menuEntires={this.state.menuEntires}
					onSpecialsClick={ this.toggleNotificationWidget}
					menuIsVisible={this.state.menuIsVisible}
				/>
				<MainElement />
				<SpecialsWidgetComponent
					notificationWidgetActive={this.state.notificationWidgetActive} 
					onCloseClick={this.toggleNotificationWidget}
					/>
			</div>
		);		
	}
}
ReactDOM.render((
	<HashRouter>
			<Route path="/" component={PortfolioEmmanuelLainas} />
	</HashRouter>
), document.getElementById('app-root'));


// WEBPACK FOOTER //
// in/js/portfolio.js